import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getValidationErrors, mapErrors } from 'icreate/common/validators';
import { shipyardValidator } from 'icreate/common/validators/shipyard/shipyard-validator';
import { ShipyardService } from '@service/shipyard.service';
import { InputSelectWithErrorComponent } from '@components/input-select-with-error/input-select-with-error.component';

@Component({
    selector: 'app-new-shipyard-dialog',
    templateUrl: './new-shipyard-dialog.component.html',
    styleUrls: ['./new-shipyard-dialog.component.css'],
    standalone: false,
})
export class NewShipyardDialogComponent implements OnInit, AfterViewInit {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            name: string;
            shipyardsNames: string[];
            isDuplicating: boolean;
        },
        private cdr: ChangeDetectorRef,
        private dialogRef: MatDialogRef<NewShipyardDialogComponent>,
        private shipyardService: ShipyardService
    ) {}

    @ViewChild('infoContainer') infoContainer: ElementRef;
    @ViewChild('shipyardNameInput') shipyardNameInput: InputSelectWithErrorComponent;

    isEditing: boolean = false;
    isDuplicating: boolean = false;
    showInfoContainer: boolean = false;
    isLoading: boolean = false;

    currentShipyardNames: string[] = [];
    nameIsRepeated: boolean = false;

    shipyardName: string;
    shipyardID: string;

    iAPICompanyNames: string[];
    filteredShipyardNames: string[] = [];

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (this.showInfoContainer && !this.infoContainer?.nativeElement.contains(event.target)) {
            this.showInfoContainer = false;
        }
    }

    async ngOnInit() {
        if (this.data && this.data.name) {
            this.isEditing = this.data.isDuplicating ? false : true;
            this.isDuplicating = this.data.isDuplicating ?? false;
            this.shipyardName = this.data.name;
            this.dialogHasErrors();
        }
        this.currentShipyardNames = this.data.shipyardsNames?.length > 0 ? this.data.shipyardsNames : [];

        const shipyards = await this.shipyardService.getiAPIShipyards();
        const result = shipyards.map(s => s.name);
        this.iAPICompanyNames = result;
    }

    ngAfterViewInit(): void {
        if (this.data.name) {
            this.shipyardNameInput.checkStringError();
        }
    }

    isCreateDisabled() {
        return this.dialogHasErrors() || !this.shipyardName;
    }

    dialogHasErrors(): boolean {
        if (this.currentShipyardNames?.length > 0) {
            let isRepeated = false;
            this.currentShipyardNames.forEach(shipyardName => {
                if (shipyardName === this.shipyardName && this.data?.name !== this.shipyardName) {
                    isRepeated = true;
                }
            });
            if (isRepeated && !this.nameIsRepeated) {
                this.nameIsRepeated = true;
                this.cdr.detectChanges();
            } else if (!isRepeated && this.nameIsRepeated) {
                this.nameIsRepeated = false;
                this.cdr.detectChanges();
            }
        }

        if (this.nameIsRepeated) return true;

        const shipyardData = {
            name: this.shipyardName,
            vessels: [],
        };
        const errors = getValidationErrors(shipyardValidator(), shipyardData);
        if (errors) {
            const mappedErrors = mapErrors(errors);
            const propertiesToCheck = Object.keys(shipyardData);
            for (let i = 0; i < propertiesToCheck.length; i++) {
                if (propertiesToCheck[i] in mappedErrors) {
                    return true;
                }
            }
        }

        if (this.data) {
            if (this.data.name === this.shipyardName && !this.isDuplicating) {
                return true;
            }
        }

        return false;
    }

    async createShipyard() {
        if (this.isCreateDisabled()) {
            return;
        }

        const shipyards = await this.shipyardService.getiAPIShipyards();
        const matchedCompany = shipyards.find(s => s.name.toLowerCase() === this.shipyardName.toLowerCase());

        this.dialogRef.close({ name: this.shipyardName, iApiId: matchedCompany?.id });
    }

    async updateShipyard() {
        if (this.isCreateDisabled()) {
            return;
        }
        this.dialogRef.close({ name: this.shipyardName });
    }

    clearForm() {
        this.dialogRef.close();
    }

    public get validatorFunction() {
        return shipyardValidator;
    }
}
